import type { FC } from "react";
import { Navigate } from "react-router-dom";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { ChatPage } from "web_myplann/Chat/Pages/ChatPage";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { getRoute } from "web_myplann/Infrastructure/Utils/UrlUtils";

export const ChatPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? (
		<ChatPage />
	) : (
		<Navigate to={getRoute(Routing.Advisor)} replace />
	);
};
